/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GrowRegistrationInput } from '../models/GrowRegistrationInput';
import type { GrowRegistrationLinkOut } from '../models/GrowRegistrationLinkOut';
import type { GrowRegistrationStatusOut } from '../models/GrowRegistrationStatusOut';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GrowconnectService {
  /**
   * Create Grow Registration
   * @param requestBody
   * @returns GrowRegistrationLinkOut Successful Response
   * @throws ApiError
   */
  public static createGrowRegistration(requestBody: GrowRegistrationInput): CancelablePromise<GrowRegistrationLinkOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/growconnect/register',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Grow Registration Status
   * @returns GrowRegistrationStatusOut Successful Response
   * @throws ApiError
   */
  public static getGrowRegistrationStatus(): CancelablePromise<GrowRegistrationStatusOut> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/growconnect/status',
    });
  }
}
